import Combobox from '@/libs/components/src/lib/form/Combobox';
import { ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import { BASE_ROLES, ROLES, UserRoles } from '@chiroup/core/types/User.type';
import { useForm } from '@chiroup/hooks/useForm';
import userService from '../../../services/user.service';
import Modal from '../../common/Modal';

type Props = {
  isOpen: OpenClosedStates;
  setIsOpen: (arg: OpenClosedStates) => void;
  clinicID?: number;
  user: any;
  closeAddUserModal: () => void;
  onSuccess: () => void;
  isEHR?: boolean;
};

const RoleSelectModal = ({
  isOpen,
  setIsOpen,
  clinicID,
  user,
  closeAddUserModal,
  onSuccess,
  isEHR,
}: Props) => {
  const { value, patchValue, registerSubmit } = useForm<{
    userID: string;
    clinicID: number;
    role: string[];
  }>({
    role: [UserRoles.Admin],
  });

  const onSubmit = async () => {
    const res = await userService.addUserToClinic(value, user.ID, clinicID, user.salesforceID);

    return res;
  };

  const onChangeRole = (val: string[]) => {
    const valToUse: any = { role: val };
    patchValue(valToUse);
  };

  const footerButtons = [
    {
      text: 'Close',
      onClick: () => setIsOpen(OpenClosedStates.Closed),
      color: ButtonColors.plainWithBorder,
    },
    {
      text: 'Confirm',
      onClick: registerSubmit(onSubmit, { onSuccess }),
      color: ButtonColors.primary,
    },
  ];

  return (
    <Modal
      isOpen={isOpen === OpenClosedStates.Open}
      close={() => setIsOpen(OpenClosedStates.Closed)}
      header={{ title: 'Add user to clinic' }}
      footer={{ buttons: footerButtons }}
    >
      <form>
        <div>
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100 dark:bg-dark-gray-500">
            <svg
              className="h-6 w-6 text-gray-600 dark:text-dark-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div className="mt-3 text-center sm:mt-5">
            <h3
              className="text-lg leading-6 font-medium text-gray-900 dark:text-dark-gray-100"
              id="modal-headline"
            >
              Add user to clinic
            </h3>
            <div className="flex justify-center items-center">
              <Combobox
                options={isEHR ? ROLES : BASE_ROLES}
                name="role"
                value={value.role}
                className="flex flex-row col-span-4 mr-4"
                onChange={onChangeRole}
                label="Role"
              />
            </div>
            <div className="mt-2">
              <p className="text-sm leading-5 text-gray-500 dark:text-dark-gray-400">
                Are you sure you wish to add this user to this clinic?
              </p>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default RoleSelectModal;
